const FALLBACK_RETURN_URL = '/';
const PARSER_ORIGIN = 'https://wosi.local';

/**
 * Aceita só caminho da própria origem (path absoluto).
 * URL absoluta, protocol-relative (`//`), barra invertida e controle
 * voltam para `/`, para o pós-login cair na rota da hierarquia.
 */
export function sanitizeInternalReturnUrl(value: string | null | undefined): string {
  if (value == null) {
    return FALLBACK_RETURN_URL;
  }

  const candidate = value.trim();
  if (!isPathAbsolute(candidate)) {
    return FALLBACK_RETURN_URL;
  }

  let resolved: URL;
  try {
    resolved = new URL(candidate, PARSER_ORIGIN);
  } catch {
    return FALLBACK_RETURN_URL;
  }

  if (resolved.origin !== PARSER_ORIGIN) {
    return FALLBACK_RETURN_URL;
  }

  const decodedPath = decodePathname(resolved.pathname);
  if (!decodedPath || !isPathAbsolute(decodedPath) || hasControlChar(decodedPath)) {
    return FALLBACK_RETURN_URL;
  }

  const safe = `${resolved.pathname}${resolved.search}${resolved.hash}`;
  if (!isPathAbsolute(safe)) {
    return FALLBACK_RETURN_URL;
  }

  return safe;
}

function isPathAbsolute(value: string): boolean {
  return (
    value.startsWith('/') &&
    !value.startsWith('//') &&
    !value.includes('\\') &&
    !value.includes('://') &&
    !hasControlChar(value)
  );
}

function hasControlChar(value: string): boolean {
  return /[\u0000-\u001F\u007F]/.test(value);
}

function decodePathname(pathname: string): string | null {
  try {
    return decodeURIComponent(pathname);
  } catch {
    return null;
  }
}
